import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { actions as userActions } from '../../../redux/users';
import {
  hideComment,
  reportComment,
  unhideComment,
  featureComment,
  unfeatureComment,
} from '../../redux/actionCreators';
import { isCommentReduxReady } from '../../redux/selectors';
import { CommentStoreState } from '../../redux/types';
import { Props } from './ActionsMenu';

type StateProps = Pick<Props, 'isCommentReduxReady'>;

type DispatchProps = Pick<
  Props,
  | 'onReportSpam'
  | 'onFeature'
  | 'onUnfeature'
  | 'onHide'
  | 'onUnhide'
  | 'onBlockUser'
>;
type OwnProps = Omit<Props, keyof (DispatchProps & StateProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  CommentStoreState
> = state => ({
  isCommentReduxReady: isCommentReduxReady(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onReportSpam: reportComment,
  onHide: hideComment,
  onUnhide: unhideComment,
  onFeature: featureComment,
  onUnfeature: unfeatureComment,
  onBlockUser: userActions.blockUser,
};

export default connect(mapStateToProps, mapDispatchToProps);
